import { Capacitor } from '@capacitor/core';
import { APP_VERSION } from 'src/environments/version';

/**
 * What the iPhone/iPad app tells the server about itself, sent on every API call (SHOWN to the user's other devices in
 * the "Already signed in" screen, the "you were signed out elsewhere" dialog and the new-device e-mail).
 *
 * Why: the server used to guess from the User-Agent, and the iOS app's User-Agent carries the app's own BUILD NUMBER
 * ("...App/52 CFNetwork..."), which showed up as if it were the phone's version. The real model and iOS version are
 * read here from the WebView's own User-Agent, which has them ("iPhone; CPU iPhone OS 17_5 like Mac OS X").
 * Android sends only the platform name (its WebView User-Agent already parses correctly on the server for the device
 * text); the server uses it to tell the phone/tablet APP apart from a browser (web / app session slots).
 */
export function clientDeviceHeaders(): Record<string, string> {
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android') return { 'X-Client-Platform': 'android' };
  if (!Capacitor.isNativePlatform() || Capacitor.getPlatform() !== 'ios') return {};
  const ua = typeof navigator !== 'undefined' ? navigator.userAgent || '' : '';
  const model = /iPad/.test(ua) ? 'iPad' : /iPhone/.test(ua) ? 'iPhone' : 'iOS device';
  const os = /OS (\d+)[_.](\d+)/.exec(ua);
  return {
    'X-Client-Platform': 'ios',
    'X-Client-Device': os ? `${model} (iOS ${os[1]}.${os[2]})` : model,
    'X-App-Version': APP_VERSION,
  };
}
